import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const styles = {
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        padding: '20px',
        maxWidth: '80%',
        width: '680px',
        position: 'relative',
    },
    closeButton: {
        position: 'absolute',
        right: '2px',
        top: '2px',
        padding: '8px',
    },
};

const TableStyle = styled(TableRow)`
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

const ProgramHistoryModal = ({ open, handleClose, historyOfPrograms}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const historyItems = historyOfPrograms.slice(indexOfFirstItem, indexOfLastItem);
    const history = useHistory();
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handlePageShift = (programName) => {
        history.push(`/programs/${programName}`);
    };
    
    const getNewString = (dateString) => {
        if (dateString === null) {
            return "In Progress"
        } else {
            const date = new Date(dateString);
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }
    }

    return (
        <Modal open={open} onClose={handleClose} style={styles.modal}>
            <Paper style={styles.modalContent}>
                <IconButton style={styles.closeButton} onClick={handleClose}>
                    <Icon>clear</Icon>
                </IconButton>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Programs</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {historyItems?.map((row, index) => (
                            <TableStyle key={index} onClick={() => handlePageShift(row.program_id)}>
                                <TableCell>{row.program_name}</TableCell>
                                <TableCell>{row.started}</TableCell>
                                <TableCell>{getNewString(row.ended)}</TableCell>
                            </TableStyle>
                        ))}
                    </TableBody>
                </Table>
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={indexOfLastItem >= historyOfPrograms.length}
                    >
                        Next
                    </button>
                </div>
            </Paper>
        </Modal>
    );
};

ProgramHistoryModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    historyOfPrograms: PropTypes.array.isRequired,
};

export default ProgramHistoryModal;